import { render, staticRenderFns } from "./DeleteSponsorDialog.vue?vue&type=template&id=575a3ace&scoped=true&"
import script from "./DeleteSponsorDialog.vue?vue&type=script&lang=js&"
export * from "./DeleteSponsorDialog.vue?vue&type=script&lang=js&"
import style0 from "./DeleteSponsorDialog.vue?vue&type=style&index=0&id=575a3ace&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "575a3ace",
  null
  
)

export default component.exports